import { useContext, createContext } from 'react';

var MotionContext = createContext(undefined);
function useVisualElementContext() {
    return useContext(MotionContext);
}

export { MotionContext, useVisualElementContext };
